const o=6,t=8,c=12;export{o as ITEM_HORIZONTAL_SPACING,c as ITEM_VERTICAL_SPACING,t as ITEM_VERTICAL_SPACING_TABLET};
//# sourceMappingURL=constants.js.map
